import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import messages from './messages';
import style from './style.module.less';

const FormErrorDisplay = () => {
  return (
    <BannerMessageV2
      className={style['form-error']}
      content={<FormattedMessage {...messages.errorOccurredMessage} />}
      status={BannerStatus.Error}
    />
  );
};

export default FormErrorDisplay;
